import React from 'react'
import moment from 'moment'

export default function DatePanel({date, onDateChange}) {
  return <div className='fc-left open-game-date-buttons'>
    <div className='fc-button-group'>
      <button 
        className='fc-prev-button fc-button fc-button-primary'
        onClick={() => onDateChange(moment(date).subtract(1, 'days')) }
      >
        <span className='fc-icon fc-icon-chevron-left' id='prev-date'></span>
      </button>&nbsp;
      <button 
        className='fc-next-button fc-button fc-button-primary'
        onClick={() => onDateChange(moment(date).add(1, 'days')) }
      >
        <span className='fc-icon fc-icon-chevron-right' id='next-date'></span>
      </button>
    </div>&nbsp;
    <button 
      className='fc-today-button fc-button fc-button-primary'
      disabled={date == moment().format('YYYY-MM-DD')}
      onClick={() => onDateChange(moment()) }>
      today
    </button>
  </div>
}
